"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var TxButtonComponent = /** @class */ (function () {
    function TxButtonComponent() {
        this.txOnClick = new core_1.EventEmitter();
    }
    TxButtonComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(TxButtonComponent.prototype, "faIconName", {
        get: function () {
            return this._faIconName;
        },
        set: function (faIconName) {
            this._faIconName = faIconName;
        },
        enumerable: true,
        configurable: true
    });
    TxButtonComponent.prototype.emitClick = function () {
        this.txOnClick.emit();
    };
    TxButtonComponent.ctorParameters = function () { return []; };
    return TxButtonComponent;
}());
exports.TxButtonComponent = TxButtonComponent;
//# sourceMappingURL=tx-button.component.js.map


// WEBPACK FOOTER //
// tx-button.component.js